import { render, staticRenderFns } from "./miPerfilSuc.vue?vue&type=template&id=14f8c303&scoped=true"
import script from "./miPerfilSuc.vue?vue&type=script&lang=js"
export * from "./miPerfilSuc.vue?vue&type=script&lang=js"
import style0 from "./miPerfilSuc.vue?vue&type=style&index=0&id=14f8c303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f8c303",
  null
  
)

export default component.exports